export default "__VITE_ASSET__D9_R5VQA__"